import { createTranslations } from '@/i18n/types';

const translations = createTranslations({
  en: { unlocked: 'Achievement unlocked!', xp: 'XP', claimReward: 'Claim reward', locked: 'Reward locked' },
  ru: { unlocked: 'Ачивка получена!', xp: 'XP', claimReward: 'Забери награду', locked: 'Награда заблокирована' },
  uz: { unlocked: 'Yutuq ochildi!', xp: 'XP', claimReward: 'Mukofotni oling', locked: 'Mukofot bloklangan' },
  fa: { unlocked: 'دستاورد باز شد!', xp: 'XP', claimReward: 'جایزه را بگیر', locked: 'جایزه قفل است' },
  pt: { unlocked: 'Conquista desbloqueada!', xp: 'XP', claimReward: 'Pegue a recompensa', locked: 'Recompensa bloqueada' },
  tr: { unlocked: 'Başarım açıldı!', xp: 'XP', claimReward: 'Ödülü al', locked: 'Ödül kilitli' },
  uk: { unlocked: 'Досягнення отримано!', xp: 'XP', claimReward: 'Забери нагороду', locked: 'Нагороду заблоковано' },
  de: { unlocked: 'Erfolg freigeschaltet!', xp: 'XP', claimReward: 'Hol dir die Belohnung', locked: 'Belohnung gesperrt' },
  es: { unlocked: '¡Logro desbloqueado!', xp: 'XP', claimReward: 'Recoge tu recompensa', locked: 'Recompensa bloqueada' },
  pl: { unlocked: 'Osiągnięcie zdobyte!', xp: 'XP', claimReward: 'Odbierz nagrodę', locked: 'Nagroda zablokowana' },
});

export default translations;
